import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestOnlinePicksStylesUK: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-zinc-950',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-zinc-950',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-yellow-400 [&>svg>path]:stroke-[#363636]',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-zinc-950',
  HOMEPAGE_HEADER_TEXT: 'text-white',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-yellow-400',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-blue-500',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#E3E3E3] hover:border-[#f0c52b] hover:bg-[#f0c52b] hover:text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#f0c52b]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-zinc-950',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-zinc-950',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-blue-500',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#78C02A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#78C02A] text-[#78C02A] [&>svg>path]:stroke-[#78C02A] [&>svg>g>path]:stroke-[#78C02A] [&>svg>path]:fill-[#78C02A] [&>svg>g>path]:fill-[#78C02A]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#78C02A]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-zinc-950',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-zinc-950',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-white',
  HOMEPAGE_ON_SALE_CTA: 'bg-blue-500',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-zinc-950',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-white',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-white',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-zinc-950 [&>.explore-icon-fill]:!fill-zinc-950 [&>g>.explore-icon-fill]:!fill-zinc-950',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-zinc-950 [&>.vector-top>path]:fill-zinc-950 [&>.vector-bottom>path]:fill-zinc-950',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-orange-400',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-neutral-100',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#44403c]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-amber-400',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-rose-500',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-blue-500',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-indigo-50',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: '!text-blue-500',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-green-200',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-blue-500',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-blue-500',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-green-200',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#78C02A]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#78C02A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#78C02A] text-[#78C02A] [&>svg>path]:stroke-[#78C02A] [&>svg>g>path]:stroke-[#78C02A] [&>svg>path]:fill-[#78C02A] [&>svg>g>path]:fill-[#78C02A]',
  LISTPAGE_BUTTON_LINK: 'text-[#78C02A]',
  LISTPAGE_ANCHOR_LINK: 'text-[#78C02A]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#78C02A]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#78C02A]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#78C02A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-green-500 text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-green-500 text-green-500  [&>svg>path]:stroke-green-500 [&>svg>g>path]:stroke-green-500 [&>svg>path]:fill-green-500 [&>svg>g>path]:fill-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-green-500',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-lime-500',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#78C02A]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#C7D2FE] [&>.vector-top>path]:fill-[#A5B4FC] [&>.vector-bottom>path]:fill-[#E0E7FF]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-blue-100 [&>circle]:stroke-blue-100 [&>path]:fill-black',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-green-50 data-[focus]:text-green-700',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-green-100',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-green-700',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}

export const bestOnlinePicksStylesCA: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-zinc-950',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-zinc-950',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-yellow-400 [&>svg>path]:stroke-[#363636]',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-zinc-950',
  HOMEPAGE_HEADER_TEXT: 'text-white',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-yellow-400',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-blue-500',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#E3E3E3] hover:border-[#f0c52b] hover:bg-[#f0c52b] hover:text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#f0c52b]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-zinc-950',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-zinc-950',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-blue-500',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#78C02A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#78C02A] text-[#78C02A] [&>svg>path]:stroke-[#78C02A] [&>svg>g>path]:stroke-[#78C02A] [&>svg>path]:fill-[#78C02A] [&>svg>g>path]:fill-[#78C02A]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#78C02A]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-zinc-950',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-zinc-950',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-white',
  HOMEPAGE_ON_SALE_CTA: 'bg-blue-500',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-zinc-950',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-white',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-white',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-zinc-950 [&>.explore-icon-fill]:!fill-zinc-950 [&>g>.explore-icon-fill]:!fill-zinc-950',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-zinc-950 [&>.vector-top>path]:fill-zinc-950 [&>.vector-bottom>path]:fill-zinc-950',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-orange-400',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-neutral-100',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#44403c]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-amber-400',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-rose-500',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-blue-500',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-indigo-50',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: '!text-blue-500',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-green-200',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-blue-500',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-blue-500',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-green-200',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#78C02A]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#78C02A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#78C02A] text-[#78C02A] [&>svg>path]:stroke-[#78C02A] [&>svg>g>path]:stroke-[#78C02A] [&>svg>path]:fill-[#78C02A] [&>svg>g>path]:fill-[#78C02A]',
  LISTPAGE_BUTTON_LINK: 'text-[#78C02A]',
  LISTPAGE_ANCHOR_LINK: 'text-[#78C02A]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#78C02A]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#78C02A]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#78C02A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-green-500 text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-green-500 text-green-500  [&>svg>path]:stroke-green-500 [&>svg>g>path]:stroke-green-500 [&>svg>path]:fill-green-500 [&>svg>g>path]:fill-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-green-500',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-lime-500',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#78C02A]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#C7D2FE] [&>.vector-top>path]:fill-[#A5B4FC] [&>.vector-bottom>path]:fill-[#E0E7FF]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-blue-100 [&>circle]:stroke-blue-100 [&>path]:fill-black',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-green-50 data-[focus]:text-green-700',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-green-100',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-green-700',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
